import React from 'react';
import AocNav from './AocNav';
import { Route, Switch } from 'react-router-dom';
import MyOrders from './myorders/MyOrders';
import ProductRange from './product-range/ProductRange';
import Presells from './presells/Presells';
import OrderPage from './view-order/OrderPage';
import CreateOrder from './create-order/CreateOrder';
import FranchiseRedirect from './FranchiseRedirect';
import TradingAgreement from './trading-agreement/TradingAgreement';
import Presell from './presells/preselldetails/PresellDetail';
import WebDeals from './web-deals/WebDeals';
import WebDealLines from './web-deals/WebDealLines';
import BestwayTransaction from './bestway-transaction/BestwayTransaction';
import ChristmasSchedule from './christmas/ChristmasSchedule';

export default function Main() {
    return (
        <main>
            <AocNav />
            <Switch>
                {/* Pass random key to force a refresh */}
                <Route exact path={'/'} render={() => <MyOrders key={Math.random()} />} />
                <Route exact path={'/product-range'} render={() => <ProductRange key={Math.random()} />} />
                <Route exact path={'/web-deals'} render={() => <WebDeals key={Math.random()} />} />
                <Route exact path={'/web-deals/:dealId'} component={WebDealLines} />
                <Route exact path={'/presells'} render={() => <Presells key={Math.random()} excludedStatuses={['ALLOCATION', 'REJECTED']} title={'Presell'} filterType={'presells'} />} />
                <Route exact path={'/allocations'} render={() => <Presells key={Math.random()} allowedStatuses={['ALLOCATION', 'REJECTED']} title={'Allocation'} filterType={'allocations'} />} />
                <Route exact path={'/trading-agreement'} render={() => <TradingAgreement />} />
                {/* As we aren't passing any props, we can use the simpler form of Route */}
                <Route exact path={'/order/create'} component={CreateOrder} />
                <Route exact path={'/order/:orderId'} component={OrderPage} />
                <Route exact path={'/franchise/:franchiseCode'} component={FranchiseRedirect} />
                <Route path={'/presell/:presellId'} component={Presell} />
                <Route
                    exact
                    path={'/bestway-transaction/:depot/:transactionId'}
                    component={BestwayTransaction}
                />
                <Route exact path={'/christmas-schedule'} component={ChristmasSchedule} />
            </Switch>
        </main>
    );
}
